import { gsap, Power2 }  from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import initSlider        from '../../includes/Slider/assets/js/slider'

gsap.registerPlugin(ScrollTrigger)

const photos = document.querySelector('section[data-photos]')
const isProject = document.body.classList.contains('single-projets')

if (photos && isProject)
{
	const galleryContainer = photos.querySelector('#galleryContainer')
	const gallery = photos.querySelector('#gallery')
	const els = gallery.querySelectorAll('.slider')
	
	gsap.set(els, {
		opacity: 0
	})
	
	photos.querySelectorAll('.photos figure').forEach(el =>
	{
		el.addEventListener('click', (e) =>
		{
			initGallery(el.dataset.index)
		})
	})
}

function hideGallery ()
{
	const galleryContainer = document.querySelector('#galleryContainer')
	
	gsap.to(galleryContainer, {
		y: 0,
		opacity: 0,
		duration: .3,
		ease: Power2.easeOut,
		onComplete: () =>
		{
			gsap.set(galleryContainer, {
				zIndex: -1
			})
		}
	})
}

function initGallery (slideIndex)
{
	const galleryContainer = document.querySelector('#galleryContainer')
	
	gsap.fromTo(galleryContainer, {
		y: 0,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: .3,
		ease: Power2.easeOut,
		onStart: () =>
		{
			gsap.set(galleryContainer, {
				zIndex: 9999
			})
		},
		onComplete: () =>
		{
			initGallerySlider(slideIndex)
		}
	})
}

function initGallerySlider (slideIndex)
{
	const galleryContainer = document.querySelector('#galleryContainer')
	const gallery = galleryContainer.querySelector('#gallery')
	
	/*gallery.querySelectorAll('.slider').forEach(el => {
	 initSlider(el)
	 })*/
	
	const els = gallery.querySelectorAll('.slider, .slider.photo .swiper-container, .slider.photo .swiper-button-prev, .slider.photo .swiper-button-next, .slider.thumbnails .item, .close')
	
	els.forEach((el, index) =>
	{
		gsap.fromTo(el, {
			y: 50,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: .3,
			delay: index * 0.1,
			ease: Power2.easeOut,
			onStart: () =>
			{
				const slider = gallery.querySelector('.slider.photo .swiper-container').swiper
				slider.slideTo(parseInt(slideIndex), 0)
			}
		})
	})
	
	gallery.querySelector('.close').addEventListener('click', () =>
	{
		els.forEach((el, index) =>
		{
			gsap.to(el, {
				y: 0,
				opacity: 0,
				duration: .3,
				//delay: index * 0.1,
				ease: Power2.easeOut,
				onComplete: () =>
				{
					hideGallery()
				}
			})
		})
	})
}
